import { render, staticRenderFns } from "./landCun.vue?vue&type=template&id=69a3d56c&scoped=true"
import script from "./landCun.vue?vue&type=script&lang=js"
export * from "./landCun.vue?vue&type=script&lang=js"
import style0 from "./landCun.vue?vue&type=style&index=0&id=69a3d56c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a3d56c",
  null
  
)

export default component.exports